import { queryOptions, useSuspenseQuery } from "@tanstack/react-query"
import { request } from "@utils/request"

export type FeatureFlags = {
  flags: Record<string, boolean>
}

export const FLAG_DEFINITIONS = [
  {
    key: "voiceBotHandover",
    label: "Voicebot handover",
    description: "Enables voicebot handover for this solution.",
  },
] as const

export type FlagKey = (typeof FLAG_DEFINITIONS)[number]["key"]

// Map the backend's flag record onto our known flags. The superpowers PUT is a full
// replacement, so we always send back every flag we know about. This is to avoid keeping old, unwanted flags in production.
export const mapFlags = (
  flags: Record<string, boolean>,
): Record<string, boolean> =>
  Object.fromEntries(
    FLAG_DEFINITIONS.map(({ key }) => [key, flags[key] ?? false]),
  )

// Read-only flags for the current user's own solution, usable anywhere in the
// app to gate UI. Flags are edited in superpowers query.
export const featureFlagsQuery = queryOptions({
  queryKey: ["featureFlags", "me"] as const,
  queryFn: () => request.get<FeatureFlags>("/api/solution/v1/flags"),
})

export const useFeatureFlag = (key: FlagKey): boolean => {
  const { data } = useSuspenseQuery(featureFlagsQuery)
  return data.flags[key] ?? false
}
